/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type SearchLocationParams = {
/**
 * Full-text search query for regions, districts, and municipalities
 */
search?: string;
/**
 * Comma-separated list of slugs
 */
slugs?: string;
};
